<template>
  <div class="main">
    <iframe
      width="100%"
      height="100%"
      id="mainframe"
      scrolling="no"
      frameborder="no"
      title="Inline Frame Example"
      allow="microphone"
      :src="`https://ll-livespeaking.liveabc.com/AIStorybook/reader/${$route.params.bookId}` ">
    </iframe>
  </div>
</template>
<script>

export default {
  name: 'Book',
  data () {
    return {

    }
  },
  props: {

  },
  mounted () {
    const iframe = document.getElementById('mainframe')
    window.addEventListener('message', (event) => {
      iframe.style.height = window.innerHeight + 'px'
    })
  },
  beforeDestroy () {
    const iframe = document.getElementById('mainframe')
    window.removeEventListener('message', (event) => {
      iframe.style.height = event.data + 'px'
    })
  },
  methods: {
    adjustIframe () {

    }
  },
  components: {
  }
}
</script>

<style lang="scss" scoped>
@import "../assets/styles/custom.scss";
  .main {
    display: flex;
    justify-content: center;
    align-items: center;
  }
  #mainframe {
    min-height: 900px;
  }

</style>
